import { render, staticRenderFns } from "./CompaniesComp.vue?vue&type=template&id=1ad7c3bc"
import script from "./CompaniesComp.vue?vue&type=script&lang=ts"
export * from "./CompaniesComp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports